module.exports = __webpack_public_path__ + "img/bill-left.cfa6ea5f.png";